import moment from 'moment';
import { getFixedValue } from '../currencyConvertion';

export function getBillingDetails({ checkIn, checkOut, bookingSpecialPricing, basePrice, total, hostServiceFee, isSpecialPriceAverage }) {

    let momentStartDate, momentEndDate, dayDifference = 0, isSpecialPricingAssigned = false, dayPrice = 0, hostSubTotal = 0;
    let isAverage = 0, hostTotal = 0, guestTotal = 0, isDayTotal = 0;
    isSpecialPricingAssigned = bookingSpecialPricing?.length > 0 ? true : false;

    if (checkIn && checkOut) {
        momentStartDate = moment(checkIn, ['DD/MM/YYYY', 'YYYY-MM-DD']);
        momentEndDate = moment(checkOut, ['DD/MM/YYYY', 'YYYY-MM-DD']);
        dayDifference = momentEndDate.diff(momentStartDate, 'days');
        if (isSpecialPricingAssigned) {
            bookingSpecialPricing?.map((item, index) => {
                dayPrice = dayPrice + Number(item?.isSpecialPrice);
            });
        } else if (isSpecialPriceAverage && isSpecialPriceAverage > 0) {
            // Use stored average price from reservation if available
            dayPrice = isSpecialPriceAverage * dayDifference;
        } else {
            // Fallback to base price calculation
            dayPrice = basePrice * dayDifference;
        }
    }

    if (isSpecialPriceAverage && isSpecialPriceAverage > 0 && !isSpecialPricingAssigned) {
        // Use stored average price directly when available
        isAverage = getFixedValue(isSpecialPriceAverage);
        dayPrice = isAverage * dayDifference;
    } else {
        isAverage = getFixedValue(Number(dayPrice) / Number(dayDifference));
        isDayTotal = isAverage * dayDifference;
        dayPrice = isDayTotal;
    }

    hostTotal = total - hostServiceFee;
    guestTotal = total;
    hostSubTotal = total;

    return {
        isAverage,
        dayPrice,
        hostTotal,
        guestTotal,
        dayDifference,
        isSpecialPricingAssigned,
        hostSubTotal
    };
};
